module.exports = __webpack_public_path__ + "img/logo.88e6bfd1.png";